import { ObjectValues } from 'src/common/tsHelpers';

export const SESSION_STATUS = {
  UNKNOWN: 'Unknown',
  IN_SESSION: 'InSession',
  DISCONNECTED: 'Disconnected',
} as const;

export const SESSION_STATUS_UI = {
  OUT_OF_SESSION: 'OUT_OF_SESSION',
  IN_SESSION: 'IN_SESSION',
  UNKNOWN: 'UNKNOWN',
  NONE: 'NONE',
} as const;
export type SessionStatus = ObjectValues<typeof SESSION_STATUS>;

export type SessionStatusUi = ObjectValues<typeof SESSION_STATUS_UI>;
